/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u2m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why do dentists recommend brushing for two minutes?`)
};

const es_timer_u2m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué los dentistas recomiendan cepillarse durante dos minutos?`)
};

const de_timer_u2m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum empfehlen Zahnärzte zwei Minuten Zähneputzen?`)
};

const nl_timer_u2m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom raden tandartsen aan twee minuten te poetsen?`)
};

const fr_timer_u2m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi les dentistes recommandent-ils de se brosser les dents pendant deux minutes ?`)
};

const it_timer_u2m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché i dentisti raccomandano di lavarsi i denti per due minuti?`)
};

const pt_br2_timer_u2m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que os dentistas recomendam escovar os dentes por dois minutos?`)
};

const pt_timer_u2m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que os dentistas recomendam escovar os dentes durante dois minutos?`)
};

const ja_timer_u2m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜ歯科医は2分間のブラッシングを推奨するのですか？`)
};

const zh_timer_u2m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么牙医建议刷牙两分钟？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u2m_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u2m_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u2m_faq3_q", locale)
	if (locale === "en") return en_timer_u2m_faq3_q(inputs)
	if (locale === "es") return es_timer_u2m_faq3_q(inputs)
	if (locale === "de") return de_timer_u2m_faq3_q(inputs)
	if (locale === "nl") return nl_timer_u2m_faq3_q(inputs)
	if (locale === "fr") return fr_timer_u2m_faq3_q(inputs)
	if (locale === "it") return it_timer_u2m_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u2m_faq3_q(inputs)
	if (locale === "pt") return pt_timer_u2m_faq3_q(inputs)
	if (locale === "ja") return ja_timer_u2m_faq3_q(inputs)
	return zh_timer_u2m_faq3_q(inputs)
};